import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=396993be&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=396993be&prod&scoped=true&lang=css"
import style1 from "./OrderDetails.vue?vue&type=style&index=1&id=396993be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396993be",
  null
  
)

export default component.exports